var render = function render(_c,_vm){return _c('div',{ref:"cell",staticClass:"grid-view__cell grid-field-single-select__cell",class:_vm.data.staticClass || ''},[_c('div',{staticClass:"grid-field-single-select"},[(_vm.props.value)?_c('div',{staticClass:"grid-field-single-select__option",class:'background-color--' + _vm.props.value.color},[_vm._v("\n      "+_vm._s(_vm.props.value.value)+"\n    ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }